import React from 'react';
import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { HttpReleaseCalendarClient } from './api/HttpReleaseCalendarClient';
import { releaseCalendarApiRef } from './plugin';
import { rootRouteRef } from './routes';

const releaseCalendarApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: releaseCalendarApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new HttpReleaseCalendarClient(discoveryApi, fetchApi),
    }),
});

// The page draws its own chrome (one full-width card), so the framework header
// is suppressed to keep the old-system rendering.
const releaseCalendarPage = PageBlueprint.make({
  params: {
    path: '/release-calendar',
    routeRef: rootRouteRef,
    title: 'Release Calendar',
    noHeader: true,
    loader: () =>
      import('./components/ReleaseCalendarPage').then(m => (
        <m.ReleaseCalendarPage />
      )),
  },
});

/**
 * New frontend system plugin for the release calendar.
 *
 * Install by adding `@accuristech/plugin-release-calendar` as an app
 * dependency with feature discovery enabled, or explicitly:
 * ```ts
 * import releaseCalendarPlugin from '@accuristech/plugin-release-calendar/alpha';
 * createApp({ features: [releaseCalendarPlugin] });
 * ```
 */
export default createFrontendPlugin({
  pluginId: 'release-calendar',
  title: 'Release Calendar',
  routes: {
    root: rootRouteRef,
  },
  extensions: [releaseCalendarApi, releaseCalendarPage],
});
